import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { ALERT_STYLES } from '../styles/alertPalette';

export default function SoftGateBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const onWarn = (e) => {
      const used = e?.detail?.used ?? null;
      const limit = e?.detail?.limit ?? null;
      setInfo({ used, limit, ts: Date.now() });
      try { api.trackEvent('soft_gate_banner_shown', { used, limit }); } catch {}
      setTimeout(() => {
        setInfo(null);
        try { api.trackEvent('soft_gate_banner_dismissed', { reason: 'timeout' }); } catch {}
      }, 10000);
    };
    window.addEventListener('usage-warning', onWarn);
    return () => window.removeEventListener('usage-warning', onWarn);
  }, []);

  if (!info) return null;
  return (
    <div
      role="status"
      style={{
        background: ALERT_STYLES.warning.background,
        borderBottom: ALERT_STYLES.warning.border,
        color: 'var(--color-text-primary)',
        padding: '10px 16px',
        textAlign: 'center',
        fontFamily: 'var(--font-display)',
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      You&apos;re nearing your free quota
      {info.limit ? ` (${info.used}/${info.limit} min)` : ''}.{' '}
      <Link
        to="/register"
        onClick={() => { try { api.trackEvent('soft_gate_banner_clicked'); } catch {} }}
        style={{ color: 'var(--loud-lime)', fontWeight: 800 }}
      >
        Create an account
      </Link>{' '}
      to keep going loud.
    </div>
  );
}
